import React from "react";

const SidePanel = () => {
  return (
    <div className="shadow-panShadow p-3 lg:p-5 rounded-md">
      <div>
        <p className="text__para mt-0 font-semibold text-dr_gray">
          Available Time Slots:
        </p>
        <ul className="mt-3">
          <li className="flex items-center justify-between mb-2">
            <p className="text-[15px] leading-6 text-dr_gray font-semibold">
              Tuesday
            </p>
            <p className="text-[15px] leading-6 text-dr_gray font-semibold">
              4:00 PM - 9:30 PM
            </p>
          </li>
          <li className="flex items-center justify-between mb-2">
            <p className="text-[15px] leading-6 text-dr_gray font-semibold">
              Wednesday
            </p>
            <p className="text-[15px] leading-6 text-dr_gray font-semibold">
              4:00 PM - 9:30 PM
            </p>
          </li>
          <li className="flex items-center justify-between mb-2">
            <p className="text-[15px] leading-6 text-dr_gray font-semibold">
              Friday
            </p>
            <p className="text-[15px] leading-6 text-dr_gray font-semibold">
              4:00 PM - 9:30 PM
            </p>
          </li>
        </ul>
        <div className="w-full flex flex-col items-center justify-center">
          <button className="btn btn-secondary rounded-md mt-10 font-semibold w-full">
            Book an appointment
          </button>
        </div>
      </div>
    </div>
  );
};

export default SidePanel;
